// Importing MathLive registers the <math-field> custom element.
import "mathlive"

export default defineNuxtPlugin(() => {})
